import { render } from "./ServiceCard.vue?vue&type=template&id=bea6f75e&scoped=true"
import script from "./ServiceCard.vue?vue&type=script&lang=js"
export * from "./ServiceCard.vue?vue&type=script&lang=js"

import "./ServiceCard.vue?vue&type=style&index=0&id=bea6f75e&scoped=true&lang=css"

import exportComponent from "/home/runcloud1user/webapps/brightflame/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bea6f75e"]])

export default __exports__